const series = {
  ff1: "FF1",
  ff2: "FF2",
  ff3: "FF3",
  ff4: "FF4",
  ff5: "FF5",
  ff6: "FF6",
  ff7: "FF7",
  ff8: "FF8",
  ff9: "FF9",
  ff10: "FF10",
  ff11: "FF11",
  ff12: "FF12",
  ff13: "FF13",
  ff14: "FF14",
  ff15: "FF15",
  ff16: "FF16",
  tactics: "TACTICS",
  theatrhythm: "THEATRHYTHM",
};

export const types = {
  main: "MAIN",
  mainRelated: "MAIN_RELATED",
  spinoff: "SPINOFF",
};

const platforms = {
  nes: "Nintendo Entertainment System",
  snes: "Super Nintendo Entertainment System",
  gba: "Game Boy Advance",
  nds: "Nintendo DS",
  n3ds: "Nintendo 3DS",
  nsw: "Nintendo Switch",

  ps1: "PlayStation",
  ps2: "PlayStation 2",
  ps3: "PlayStation 3",
  ps4: "PlayStation 4",
  ps5: "PlayStation 5",
  psp: "PlayStation Portable",

  win: "Windows",
  wsc: "WonderSwan Color",

  ios: "iOS",
  and: "Android",
};

// Figuring out a data structure that makes sense here
export const allGames = [
  {
    id: "1",
    name: "Final Fantasy",
    shareName: "FF I",
    type: types.main,
    series: series.ff1,
    emoji: `💎`,
    isMMO: false,
    releases: [
      {
        year: 1987,
        platforms: [platforms.nes],
      },
      {
        year: 2000,
        platforms: [platforms.wsc],
      },
      {
        year: 2002,
        platforms: [platforms.ps1],
        title: "Final Fantasy Origins",
      },
      {
        year: 2004,
        platforms: [platforms.gba],
        title: "Final Fantasy I & II: Dawn of Souls",
      },
      {
        year: 2007,
        platforms: [platforms.psp],
      },
      {
        year: 2021,
        platforms: [
          platforms.win,
          platforms.nsw,
          platforms.ps4,
          platforms.ios,
          platforms.and,
        ],
        title: "Final Fantasy Pixel Remaster",
      },
    ],
  },
  {
    id: "2",
    name: "Final Fantasy II",
    shareName: "FF II",
    type: types.main,
    series: series.ff2,
    emoji: `💬`,
    isMMO: false,
    releases: [
      {
        year: 1988,
        platforms: "NES",
      },
      {
        year: 2001,
        platforms: "WonderSwan Color",
      },
      {
        year: 2002,
        platforms: "PlayStation",
        title: "Final Fantasy Origins",
      },
      {
        year: 2004,
        platforms: "Game Boy Advance",
        title: "Final Fantasy I & II: Dawn of Souls",
      },
      {
        year: 2007,
        platforms: "PlayStation Portable",
      },
      {
        year: 2021,
        platforms: [
          platforms.win,
          platforms.nsw,
          platforms.ps4,
          platforms.ios,
          platforms.and,
        ],
        title: "Final Fantasy II Pixel Remaster",
      },
    ],
  },
  {
    id: "3",
    name: "Final Fantasy III",
    shareName: "FF III",
    type: types.main,
    series: series.ff3,
    emoji: `🧅`,
    isMMO: false,
    releases: [
      {
        year: 1990,
        platforms: "NES",
      },
      {
        year: 2006,
        platforms: "Nintendo DS",
        notes: "3D remake",
      },
      {
        year: 2021,
        platforms: [
          platforms.win,
          platforms.nsw,
          platforms.ps4,
          platforms.ios,
          platforms.and,
        ],
        title: "Final Fantasy III Pixel Remaster",
      },
    ],
  },
  {
    id: "4",
    name: "Final Fantasy IV",
    shareName: "FF IV",
    type: types.main,
    series: series.ff4,
    emoji: `🌕`,
    isMMO: false,
    releases: [
      {
        year: 1991,
        platforms: "Super NES",
      },
      {
        year: 2001,
        platforms: "PlayStation",
        title: "Final Fantasy Chronicles",
      },
      {
        year: 2005,
        platforms: "Game Boy Advance",
        title: "Final Fantasy IV Advance",
      },
      {
        year: 2007,
        platforms: "Nintendo DS",
        notes: "3D remake",
      },
      {
        year: 2011,
        platforms: "PlayStation Portable",
        title: "Final Fantasy IV: The Complete Collection",
      },
      {
        year: 2021,
        platforms: [
          platforms.win,
          platforms.nsw,
          platforms.ps4,
          platforms.ios,
          platforms.and,
        ],
        title: "Final Fantasy IV Pixel Remaster",
      },
    ],
  },
  {
    id: "4-TAY",
    name: "Final Fantasy IV: The After Years",
    shareName: "FF IV: The After Years",
    type: types.mainRelated,
    series: series.ff4,
    emoji: "🐋",
    isMMO: false,
  },
  {
    id: "5",
    name: "Final Fantasy V",
    shareName: "FF V",
    type: types.main,
    series: series.ff5,
    emoji: `🐥`,
    isMMO: false,
  },
  {
    id: "6",
    name: "Final Fantasy VI",
    shareName: "FF VI",
    type: types.main,
    series: series.ff6,
    emoji: `🤡`,
    isMMO: false,
  },
  {
    id: "7",
    name: "Final Fantasy VII",
    shareName: "FF VII",
    type: types.main,
    series: series.ff7,
    emoji: `☄️`,
    isMMO: false,
  },
  {
    id: "7-REMAKE",
    name: "Final Fantasy VII Remake",
    shareName: "FF VII Remake",
    type: types.mainRelated,
    series: series.ff7,
    emoji: `🏍️`,
    isMMO: false,
  },
  {
    id: "7-CC",
    name: "Crisis Core: Final Fantasy VII",
    shareName: "Crisis Core: FF VII",
    type: types.mainRelated,
    series: series.ff7,
    emoji: `🙎🏻‍♂️`,
    isMMO: false,
  },
  {
    id: "7-DOC",
    name: "Dirge of Cerberus: Final Fantasy VII",
    shareName: "Dirge of Cerberus: FF VII",
    type: types.mainRelated,
    series: series.ff7,
    emoji: `😈`,
    isMMO: false,
  },
  {
    id: "8",
    name: "Final Fantasy VIII",
    shareName: "FF VIII",
    type: types.main,
    series: series.ff8,
    emoji: `👩‍🏫`,
    isMMO: false,
  },
  {
    id: "9",
    name: "Final Fantasy IX",
    shareName: "FF IX",
    type: types.main,
    series: series.ff9,
    emoji: `🧙‍♂️`,
    isMMO: false,
  },
  {
    id: "10",
    name: "Final Fantasy X",
    shareName: "FF X",
    type: types.main,
    series: series.ff10,
    emoji: `🏐`,
    isMMO: false,
  },
  {
    id: "10-2",
    name: "Final Fantasy X-2",
    shareName: "FF X-2",
    type: types.mainRelated,
    series: series.ff10,
    emoji: `👗`,
    isMMO: false,
  },
  {
    id: "11",
    name: "Final Fantasy XI",
    shareName: "FF XI",
    type: types.main,
    series: series.ff11,
    emoji: `🐚`,
    isMMO: true,
  },
  {
    id: "12",
    name: "Final Fantasy XII",
    shareName: "FF XII",
    type: types.main,
    series: series.ff12,
    emoji: `⚖️`,
    isMMO: false,
  },
  {
    id: "12-RW",
    name: "Final Fantasy XII: Revenant Wings",
    shareName: "FF XII: Revenant Wings",
    type: types.mainRelated,
    series: series.ff12,
    emoji: `✍️`,
    isMMO: false,
  },
  {
    id: "13",
    name: "Final Fantasy XIII",
    shareName: "FF XIII",
    type: types.main,
    series: series.ff13,
    emoji: `⚡️`,
    isMMO: false,
  },
  {
    id: "13-2",
    name: "Final Fantasy XIII-2",
    shareName: "FF XIII-2",
    type: types.mainRelated,
    series: series.ff13,
    emoji: `👩🏻‍🎤`,
    isMMO: false,
  },
  {
    id: "13-3",
    name: "Lightning Returns: Final Fantasy XIII",
    shareName: "Lightning Returns: XIII",
    type: types.mainRelated,
    series: series.ff13,
    emoji: `⏰`,
    isMMO: false,
  },
  {
    id: "14",
    name: "Final Fantasy XIV",
    shareName: "FF XIV",
    type: types.main,
    series: series.ff14,
    emoji: `⏳`,
    isMMO: true,
  },
  {
    id: "15",
    name: "Final Fantasy XV",
    shareName: "FF XV",
    type: types.main,
    series: series.ff15,
    emoji: `🚗`,
    isMMO: false,
  },
  {
    id: "16",
    name: "Final Fantasy XVI",
    shareName: "FF XVI",
    type: types.main,
    series: series.ff16,
    emoji: `🐶`,
    isMMO: false,
  },
  {
    id: "FFT",
    name: "Final Fantasy Tactics",
    shareName: "FF Tactics",
    type: types.spinoff,
    series: series.tactics,
    emoji: `♈️`,
    isMMO: false,
  },
  {
    id: "FFTA",
    name: "Final Fantasy Tactics Advance",
    shareName: "FF Tactics Advance",
    type: types.spinoff,
    series: series.tactics,
    emoji: `🧑‍⚖️`,
    isMMO: false,
  },
  {
    id: "FFTA 2",
    name: "Final Fantasy Tactics Advance 2",
    shareName: "FF Tactics Advance 2",
    type: types.spinoff,
    series: series.tactics,
    emoji: `💼`,
    isMMO: false,
  },
  {
    id: "SOP",
    name: "Stranger of Paradise: Final Fantasy Origin",
    shareName: "Stranger of Paradise",
    type: types.mainRelated,
    series: series.ff1,
    emoji: `📱`,
    isMMO: false,
  },
];

export const mainSeries = allGames.filter((game) => game.type === types.main);
